"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const base_1 = require("./base");
const configureFramework = (Session, Authoriser, language) => (0, base_1.configureFramework)(Session, 'OK_ES', language, Authoriser);
exports.configureFramework = configureFramework;
//# sourceMappingURL=index.js.map